import { Box, IconButton } from '@mui/material'

interface Props {
  size?: number
  isButton?: boolean
  color?: string
  children: JSX.Element
}

export function IconCover({
  size = 40,
  isButton = false,
  color = 'secondary.light',
  children,
}: Props) {
  return (
    <Box>
      {isButton ? (
        <IconButton
          sx={{
            height: `${size}px`,
            width: `${size}px`,
            borderRadius: '50%',
            backgroundColor: color,
          }}
        >
          {children}
        </IconButton>
      ) : (
        <Box
          sx={{
            height: `${size}px`,
            width: `${size}px`,
            borderRadius: '50%',
            backgroundColor: color,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {children}
        </Box>
      )}
    </Box>
  )
}
